import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { SharedService } from "./shared.service";

@Injectable()
export class PlanGuard  {

    constructor(public sharedService: SharedService, public router: Router) {}

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

        return this.sharedService.plan$.pipe(map((plan) => {
            if(plan?.Status === "Complete")
                return true;
            else {
                this.router.navigate(['/app/dashboard']);
                return false;
            }
        }));
    }
}
